// src/components/MandatoryNotificationModal.js
import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import './MandatoryNotificationModal.css';

const MandatoryNotificationModal = ({ isOpen, onClose, title, description, extraInfo }) => {
    if (!isOpen) return null;

    return (
        <div className="mandatory-modal-overlay">
            <div className="mandatory-modal-content">
                <div className="mandatory-modal-icon-container">
                    <FaExclamationTriangle className="mandatory-modal-icon-large" />
                </div>
                
                <h2 className="mandatory-modal-title">
                    <FaExclamationTriangle className="mandatory-modal-icon-small" /> {title}
                </h2>
                
                <div className="mandatory-modal-body">
                    <p className="mandatory-modal-description">{description}</p>
                    {extraInfo && (
                        <p className="mandatory-modal-extra-info">
                            {extraInfo}
                        </p>
                    )}
                </div>

                <div className="mandatory-modal-footer">
                    <button 
                        className="mandatory-modal-button" 
                        onClick={onClose}
                    >
                        Entendido, continuar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MandatoryNotificationModal;
